import { render, staticRenderFns } from "./PriceTwoTheme0.vue?vue&type=template&id=0e63f2b4&scoped=true"
import script from "./PriceTwoTheme0.vue?vue&type=script&lang=js"
export * from "./PriceTwoTheme0.vue?vue&type=script&lang=js"
import style0 from "./PriceTwoTheme0.vue?vue&type=style&index=0&id=0e63f2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63f2b4",
  null
  
)

export default component.exports